import {FC, useState} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {TabPanel} from '../Core/UI';
import {observer} from 'mobx-react-lite';
import {LeadAssignmentPool} from './Leads/LeadAssignmentPool';
import EditXfers from '../Agent/EditXfers/EditXfers';

const Setting: FC = () => {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <div style={{width: '100%'}}>
            <Tabs value={tabIndex} centered onChange={(_e, v) => setTabIndex(v)}>
                <Tab label="AA Lead assignment pool" />
                <Tab label="DEL Lead assignment pool" />
                <Tab label="BDS Transfer Form" />
            </Tabs>
            <TabPanel value={tabIndex} index={0}>
                <LeadAssignmentPool type={'AA'} />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
                <LeadAssignmentPool type={'DEL'} />
            </TabPanel>
            <TabPanel value={tabIndex} index={2}>
                <EditXfers />
            </TabPanel>
        </div>
    );
};

export default observer(Setting);
